import { useEffect, useState, useCallback } from 'react'
import './DemoSection.css'
import { commitCheckoutScenario, branchForkScenario, type Scenario } from '../../scenarios'

// ClaudeAnimation scenes (synced with commit-checkout frames)
const CLAUDE_SCENES = [
  // Scene 1: Claude working
  [
    `╭─────────────────────────────────────╮
│  HARNESS [init]           YOLO MODE │
│                                     │
│                                     │
│                                     │
│                                     │
│         ▐▛███▜▌                     │
│        ▝▜█████▛▘                    │
│          ▘▘ ▝▝                      │
│                                     │
│   $ npm install                     │
│   > installing...                   │
╰─────────────────────────────────────╯`,
    `╭─────────────────────────────────────╮
│  HARNESS [init]           YOLO MODE │
│                                     │
│                                     │
│                                     │
│                                     │
│         ▐█▛███▜                     │
│        ▝▜█████▛▘                    │
│          ▘▘  ▝▝                     │
│                                     │
│   $ npm install                     │
│   > installing...                   │
╰─────────────────────────────────────╯`,
  ],
  // Scene 2: Claude says "let me save"
  [
    `╭─────────────────────────────────────╮
│  HARNESS [init]           YOLO MODE │
│                                     │
│            . - - - - - - - .        │
│            ┊ let me save   ┊        │
│            '- - - - - - - -'        │
│         ▐▛███▜▌   /                 │
│        ▝▜█████▛▘                    │
│          ▘▘ ▝▝                      │
│                                     │
│   $ npm install                     │
│   > done                            │
╰─────────────────────────────────────╯`,
    `╭─────────────────────────────────────╮
│  HARNESS [init]           YOLO MODE │
│                                     │
│            .- - - - - - - -.        │
│            ┊ let me save   ┊        │
│            ' - - - + - - - '        │
│         ▐█▛███▜   /                 │
│        ▝▜█████▛▘                    │
│          ▘▘  ▝▝                     │
│                                     │
│   $ npm install                     │
│   > done                            │
╰─────────────────────────────────────╯`,
  ],
  // Scene 3: Saving transition
  [
    `╭─────────────────────────────────────╮
│  HARNESS [init]           YOLO MODE │
│                                     │
│            . - - - - - - - .        │
│   ╭────────────────────────────╮    │
│   |     ░░ SAVING STATE ░░     |    │
│   ╰────────────────────────────╯    │
│        ▝▜█████▛▘                    │
│          ▘▘ ▝▝                      │
│                                     │
│   $ harness commit -m 'install'     │
│   > committed                       │
╰─────────────────────────────────────╯`,
    `╭─────────────────────────────────────╮
│  HARNESS [init]           YOLO MODE │
│                                     │
│            . - - - - - - - .        │
│   ╭────────────────────────────╮    │
│   |     ▓▓ SAVING STATE ▓▓     |    │
│   ╰────────────────────────────╯    │
│        ▝▜█████▛▘                    │
│          ▘▘ ▝▝                      │
│                                     │
│   $ harness commit -m 'install'     │
│   > committed                       │
╰─────────────────────────────────────╯`,
  ],
  // Scene 4: Claude tries something risky
  [
    `╭─────────────────────────────────────╮
│  HARNESS [install]        YOLO MODE │
│            . - - - - - - - .        │
│            ┊ hmm let me    ┊        │
│            ┊ try this...   ┊        │
│            '- - - - - - - -'        │
│         ▐▛███▜▌   /                 │
│        ▝▜█████▛▘                    │
│          ▘▘ ▝▝                      │
│                                     │
│   $ rm -rf /                        │
│   > ERROR: everything broken        │
╰─────────────────────────────────────╯`,
    `╭─────────────────────────────────────╮
│  HARNESS [install]        YOLO MODE │
│            .- - - - - - - -.        │
│            ┊ hmm let me    ┊        │
│            ┊ try this...   ┊        │
│            ' - - - + - - - '        │
│         ▐█▛███▜   /                 │
│        ▝▜█████▛▘                    │
│          ▘▘  ▝▝                     │
│                                     │
│   $ rm -rf /                        │
│   > ERROR: everything broken        │
╰─────────────────────────────────────╯`,
  ],
  // Scene 5: Claude panics
  [
    `╭─────────────────────────────────────╮
│  HARNESS [install]        YOLO MODE │
│                                     │
│            . - - - - - - - .        │
│            ┊ OOPS! recover ┊        │
│            '- - - - - - - -'        │
│         ▐x███x▌   /                 │
│        ▝▜█████▛▘                    │
│         ▘▘  ▝▝                      │
│                                     │
│   $ rm -rf /                        │
│   > ERROR: everything broken        │
╰─────────────────────────────────────╯`,
    `╭─────────────────────────────────────╮
│  HARNESS [install]        YOLO MODE │
│                                     │
│            .- - - - - - - -.        │
│            ┊ OOPS! recover ┊        │
│            ' - - - + - - - '        │
│         ▐▛███▜▌   /                 │
│        ▝▜█████▛▘                    │
│          ▘▘ ▝▝                      │
│                                     │
│   $ rm -rf /                        │
│   > ERROR: everything broken        │
╰─────────────────────────────────────╯`,
  ],
  // Scene 6: Restoring
  [
    `╭─────────────────────────────────────╮
│  HARNESS                  YOLO MODE │
│                                     │
│            . - - - - - - - .        │
│   ╭────────────────────────────╮    │
│   |      ░░ RESTORING ░░       |    │
│   ╰────────────────────────────╯    │
│        ▝▜█████▛▘                    │
│          ▘▘ ▝▝                      │
│                                     │
│   $ harness checkout init           │
│   > detached                        │
╰─────────────────────────────────────╯`,
    `╭─────────────────────────────────────╮
│  HARNESS                  YOLO MODE │
│                                     │
│            . - - - - - - - .        │
│   ╭────────────────────────────╮    │
│   |      ▓▓ RESTORING ▓▓       |    │
│   ╰────────────────────────────╯    │
│        ▝▜█████▛▘                    │
│          ▘▘ ▝▝                      │
│                                     │
│   $ harness checkout init           │
│   > detached                        │
╰─────────────────────────────────────╯`,
  ],
  // Scene 7: All good!
  [
    `╭─────────────────────────────────────╮
│  HARNESS [init]           YOLO MODE │
│                                     │
│            . - - - - - - - .        │
│            ┊ all good!(^_^)┊        │
│            '- - - - - - - -'        │
│         ▐▛███▜▌   /                 │
│        ▝▜█████▛▘                    │
│          ▘▘ ▝▝                      │
│                                     │
│   $ harness checkout init           │
│   > Checkout SUCCESS!               │
╰─────────────────────────────────────╯`,
    `╭─────────────────────────────────────╮
│  HARNESS [init]           YOLO MODE │
│                                     │
│            .- - - - - - - -.        │
│            ┊ all good!(^O^)┊        │
│            ' - - - + - - - '        │
│         ▐▛███▜▌   /                 │
│        ▝▜█████▛▘                    │
│         ▘▘   ▝▝                     │
│                                     │
│   $ harness checkout init           │
│   > Checkout SUCCESS!               │
╰─────────────────────────────────────╯`,
  ],
]

const SCENE_DURATION = 2500 // ms per scene
const FRAME_DURATION = 400 // ms per internal frame

function ProgressBar({ current, total }: { current: number; total: number }) {
  const percentage = Math.round((current / total) * 100)
  const barWidth = 30
  const filled = Math.round((current / total) * barWidth)
  const empty = barWidth - filled

  const bar = '#'.repeat(filled) + '-'.repeat(empty)
  const percentStr = `t=${percentage}%`.padEnd(6)

  return <span>{percentStr} [{bar}]</span>
}

export function DemoSection() {
  const [sceneIndex, setSceneIndex] = useState(0)
  const [frameIndex, setFrameIndex] = useState(0)
  const [isPlaying, setIsPlaying] = useState(true)

  const totalScenes = CLAUDE_SCENES.length
  const commitFrame = commitCheckoutScenario.frames[sceneIndex]
  const claudeFrame = CLAUDE_SCENES[sceneIndex][frameIndex]

  const goToNext = useCallback(() => {
    if (sceneIndex < totalScenes - 1) {
      setSceneIndex(sceneIndex + 1)
    } else {
      setIsPlaying(false)
    }
  }, [sceneIndex, totalScenes])

  const goToPrev = useCallback(() => {
    if (sceneIndex > 0) {
      setSceneIndex(sceneIndex - 1)
    }
  }, [sceneIndex])

  const togglePlay = useCallback(() => {
    if (sceneIndex >= totalScenes - 1) {
      setSceneIndex(0)
      setIsPlaying(true)
    } else {
      setIsPlaying(!isPlaying)
    }
  }, [isPlaying, sceneIndex, totalScenes])

  const RESET = useCallback(() => {
    setSceneIndex(0)
    setIsPlaying(false)
  }, [])

  // Auto-play scene progression
  useEffect(() => {
    if (!isPlaying) return
    const timer = setInterval(goToNext, SCENE_DURATION)
    return () => clearInterval(timer)
  }, [isPlaying, goToNext])

  // Internal frame animation (for Claude blinking)
  useEffect(() => {
    const timer = setInterval(() => {
      setFrameIndex((PREV) => (PREV + 1) % 2)
    }, FRAME_DURATION)
    return () => clearInterval(timer)
  }, [])

  // Keyboard controls
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return
      if (e.ctrlKey || e.metaKey || e.altKey) return

      switch (e.key) {
        case ' ':
          e.preventDefault()
          togglePlay()
          break
        case 'k':
        case 'ArrowLeft':
          e.preventDefault()
          goToPrev()
          break
        case 'j':
        case 'ArrowRight':
          e.preventDefault()
          goToNext()
          break
        case 'r':
          e.preventDefault()
          RESET()
          break
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [togglePlay, goToPrev, goToNext, RESET])

  return (
    <section className="demo-section">
      <div className="divider">{'*'.repeat(112)}</div>

      {/* Controls */}
      <div className="demo-section__controls">
        <div className="demo-section__control-group">
          <span className="demo-section__label" onClick={togglePlay}>[SPACE]</span>
          <span className="demo-section__shortcut">{isPlaying ? 'PAUSE' : 'PLAY'}</span>
        </div>
        <div className="demo-section__control-group">
          <span className="demo-section__label" onClick={RESET}>[R]</span>
          <span className="demo-section__shortcut">RESET</span>
        </div>
        <div className="demo-section__control-group">
          <span className="demo-section__label" onClick={goToPrev}>[K/←]</span>
          <span className="demo-section__shortcut">PREV</span>
        </div>
        <div className="demo-section__control-group">
          <span className="demo-section__label" onClick={goToNext}>[J/→]</span>
          <span className="demo-section__shortcut">NEXT</span>
        </div>
      </div>

      {/* Two-column layout: Animation | Timeline */}
      <div className="demo-section__columns">
        {/* Left: Claude Animation */}
        <div className="demo-section__left">
          <pre className="demo-section__claude-frame">{claudeFrame}</pre>
        </div>

        {/* Right: Commit-Checkout Timeline + Status + Progress */}
        <div className="demo-section__right">
          <div className="demo-section__right-content">
            <pre className="demo-section__timeline-frame">{commitFrame.ascii}</pre>
            <div className="demo-section__footer">
              <div className="demo-section__status-line">status: {commitFrame.label}</div>
              <div className="demo-section__progress">
                <ProgressBar current={sceneIndex + 1} total={totalScenes} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="demo-section__caption">
        Checkpoint. Fail. Rewind. Succeed.
      </p>
      <p className="demo-section__description">
        The agent decides when to stop, when to rewind, and what to change before moving forward again.
        <br />
        Harness treats time and runtime as tools the agent can control, not fixed rules it must obey.
      </p>
    </section>
  )
}

// Branch & Fork section (separate, below)
export function BranchForkDemo() {
  const [frameIndex, setFrameIndex] = useState(0)
  const [isPlaying, setIsPlaying] = useState(true)

  const scenario: Scenario = branchForkScenario
  const currentFrame = scenario.frames[frameIndex]
  const totalFrames = scenario.frames.length

  const goToNext = useCallback(() => {
    if (frameIndex < totalFrames - 1) {
      setFrameIndex(frameIndex + 1)
    } else {
      setIsPlaying(false)
    }
  }, [frameIndex, totalFrames])

  const goToPrev = useCallback(() => {
    if (frameIndex > 0) {
      setFrameIndex(frameIndex - 1)
    }
  }, [frameIndex])

  const togglePlay = useCallback(() => {
    if (frameIndex >= totalFrames - 1) {
      setFrameIndex(0)
      setIsPlaying(true)
    } else {
      setIsPlaying(!isPlaying)
    }
  }, [isPlaying, frameIndex, totalFrames])

  const RESET = useCallback(() => {
    setFrameIndex(0)
    setIsPlaying(false)
  }, [])

  // Auto-play
  useEffect(() => {
    if (!isPlaying) return
    const timer = setInterval(goToNext, 1500)
    return () => clearInterval(timer)
  }, [isPlaying, goToNext])

  return (
    <section className="branch-fork-demo">
      <div className="divider">{'*'.repeat(112)}</div>

      {/* Controls */}
      <div className="demo-section__controls">
        <div className="demo-section__control-group">
          <span className="demo-section__label" onClick={togglePlay}>[SPACE]</span>
          <span className="demo-section__shortcut">{isPlaying ? 'PAUSE' : 'PLAY'}</span>
        </div>
        <div className="demo-section__control-group">
          <span className="demo-section__label" onClick={RESET}>[R]</span>
          <span className="demo-section__shortcut">RESET</span>
        </div>
        <div className="demo-section__control-group">
          <span className="demo-section__label" onClick={goToPrev}>[K/←]</span>
          <span className="demo-section__shortcut">PREV</span>
        </div>
        <div className="demo-section__control-group">
          <span className="demo-section__label" onClick={goToNext}>[J/→]</span>
          <span className="demo-section__shortcut">NEXT</span>
        </div>
      </div>

      {/* Graph */}
      <div className="branch-fork-demo__graph">
        <pre className="branch-fork-demo__diagram">{currentFrame.ascii}</pre>
      </div>

      {/* Progress bar */}
      <div className="demo-section__progress">
        <ProgressBar current={frameIndex + 1} total={totalFrames} />
      </div>

      {/* Status */}
      <div className="demo-section__status">
        <span className="demo-section__title">HARNESS / branch & fork</span>
        <span className="demo-section__step-label">status: {currentFrame.label}</span>
      </div>
    </section>
  )
}
